import { Icon } from '@/components/icons/svg-icons';
import { inputFieldStyles } from './input-field.style';
import { forwardRef, useState } from 'react';

type InputFieldPasswordProps = {
	className?: string;
	children?: React.ReactNode;
	isError?: boolean;
} & React.ComponentPropsWithRef<'input'>

export const InputFieldPassword = forwardRef<HTMLInputElement, InputFieldPasswordProps>(({
	className,
	children,
	isError,
	...otherProps 
}, ref) => {
	const [isShow, setIsShow] = useState(false);

	return (
		<div className={className} data-error={isError}>
			<Icon name="lock-solid" />
			<input
				type={isShow ? 'text' : 'password'}
				className={inputFieldStyles.inputText}
				{...otherProps}
				ref={ref} 
			/>
			<div onClick={() => setIsShow((prev) => !prev)}>
				{isShow ? <Icon name="eye-open" /> : <Icon name="eye-close" />}
			</div>
			{children}
		</div>
	);
});

InputFieldPassword.displayName = 'InputFieldPassword';